import Backbone from 'backbone'
import template from './logician-examples-view.hbs'
import logicianExample, { statement3, twoStatements, threeStatements, rollupExample } from 'scoreboard/components/logic/logician-example'
import FormView from 'scoreboard/components/form-view'

const LogicianExamplesView = Backbone.View.extend(/** @lends {LogicianExamplesView} */{

	events: {
		'click .read-from-dom': 'onClickReadFromDom',
		'click .blank-example': 'onClickBlankExample',
		'click .else-only-example': 'onClickElseOnlyExample',
		'click .two-statements-example': 'onClickTwoStatementsExample',
		'click .three-statements-example': 'onClickThreeStatementsExample',
		'click .rollup-example': 'onClickRollupExample',
		'click .test': 'onClickTest'
	},

	render: function() {
		this.formView = new FormView({ el: this.el })
		this.$el.html(template())
		this.$el.css({
			'max-height': '100%',
			'overflow': 'auto'
		})

		//this.onClickBlankExample()
		//this.onClickTwoStatementsExample()
		this.onClickThreeStatementsExample()
		//this.onClickRollupExample()

		this.formView.start()
		return this
	},

	onClickReadFromDom: function() {
		console.dir(this.logician.readFromDom())
	},

	onClickBlankExample: function() {
		this.renderExample()
	},

	onClickElseOnlyExample: function() {
		this.renderExample([ statement3 ])
	},

	onClickTwoStatementsExample: function() {
		this.renderExample(twoStatements)
	},

	onClickThreeStatementsExample: function() {
		this.renderExample(threeStatements)
	},

	onClickRollupExample: function() {
		this.renderExample(rollupExample)
	},

	renderExample: function(statements) {
		this.logician?.stopListening()
		this.logician = logicianExample({
			statements,
			formView: this.formView
		})
		this.$('.logician-container').html(this.logician.el)
		this.logician.render()

		this.formView.start()

		this.onClickReadFromDom()
	},

	onClickTest: function() {
		console.log(this.logician?.test())
	},

	autoRemove: true

})

export default LogicianExamplesView
